import React from 'react';

import Address from './Address';

const BadesulAddressWrapper = ({ selectedBusinessUser, form }) => {
  if (!selectedBusinessUser || !selectedBusinessUser.user) {
    return null;
  }

  return (
    <div className="address-wrapper" style={{ padding: '1rem' }}>
      <Address address={selectedBusinessUser.user.address || {}} form={form} />
    </div>
  );
};

export default BadesulAddressWrapper;
